import { useStateMachine } from 'little-state-machine';
import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import NextBtn from '../../../../../Components/Buttons/NextBtn';
import PreviousBtn from '../../../../../Components/Buttons/PreviousBtn';
import SubmitBtn from '../../../../../Components/Buttons/SubmitBtn';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import updateAction from '../../updateAction';
import clearStore from '../../clearStore';
import { postingDataGenerator } from '../EventStep5';
import CancelFormButton from './CancelFormButton';
import { ErrorMessageHandler } from '../../../../../_helpers/_methods';

function NavigationButtonGroup({
  hasPrevious = true,
  hasNext = true,
  isSubmit = false,
  isLoading = false,
  backTo = null,
  showSubmit
}) {
  const navigate = useNavigate();
  const { state } = useStateMachine(updateAction);
  const { actions } = useStateMachine({ updateAction, clearStore });
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleEventPatch = async (data) => {
    try {
      setSubmitLoading(true);
      await fetchWrapper.patch(`/event/${showSubmit}/`, data);
      toast.success('Event Updated Successfully');
      navigate(`/admin/events/${showSubmit}`);
      actions.clearStore();
      setSubmitLoading(false);
    } catch (error) {
      setSubmitLoading(false);
      ErrorMessageHandler(error);
    }
  };
  const handleSubmit = () => {
    let postingData = { ...state.event };
    postingData = postingDataGenerator(postingData);
    handleEventPatch(postingData);
  };
  return (
    <div className="d-flex align-items-center justify-content-between">
      <CancelFormButton backTo={backTo} />
      <div className="d-flex">
        {hasPrevious && (
          <PreviousBtn
            className="me-2 btn-sm"
            onClick={() => {
              navigate(-1);
            }}
          />
        )}
        {hasNext && (
          <Fragment>
            {isSubmit ? <SubmitBtn isLoading={isLoading} /> : <NextBtn isLoading={isLoading} />}
          </Fragment>
        )}
        {showSubmit && (
          <SubmitBtn
            isLoading={submitLoading}
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          />
        )}
      </div>
    </div>
  );
}

export default NavigationButtonGroup;
